import GeneralInformations from './GeneralInformations';

export default GeneralInformations;
